export default __webpack_public_path__ + "static/media/pnsv_2dolugar.3bc6be57.png";